import { RenderLeafProps } from "slate-react";
import { ElementProps } from "./types";
import { h4 } from "./styles";

export const renderLeaf =
  ({ _strong }: ElementProps) =>
    ({ attributes, children, leaf }: RenderLeafProps & { leaf: any }) => {
      if (leaf.color || leaf.liFontSize) {
        children = (
          <span
            style={{ ...(leaf.color && { color: leaf.color as any }), ...(_strong && { ..._strong }) }}
            {...(leaf.liFontSize && { className: `rt-li-${leaf.liFontSize}` })}
          >
            {children}
          </span>
        );
      }

      if (leaf.bold && !leaf?.liFontSize) {
        children = (
          <span
            style={{
              ...h4,
              display: "inline",
            }}
          >
            {children}
          </span>
        );
      }

      if (leaf.italic) {
        children = <em>{children}</em>;
      }

      if (leaf.sub) {
        children = <sub>{children}</sub>;
      }

      if (leaf.sup) {
        children = <sup>{children}</sup>;
      }

      if (leaf.underline) {
        children = <u>{children}</u>;
      }

      if (leaf.strikethrough) {
        children = <del>{children}</del>;
      }

      return <span {...attributes}>{children}</span>;
    };
